import { createSlice } from '@reduxjs/toolkit';
import consoleLogDev from '../Helpers/loggingHelper';
import EventEmitter from 'events';

EventEmitter.defaultMaxListeners = 50;

const eventEmitter = createSlice({
    name: 'eventEmitter',
    initialState: {},
    reducers: {
        ensureEmitter(state, action) {
            if (Object.prototype.hasOwnProperty.call(state, action.payload)) { //state[action.payload.key]) {
                return state;
            } else {
                var emitter = new EventEmitter();
                state[action.payload] = emitter;
            }
        }
    }
});

export const { name, actions, reducer } = eventEmitter;